var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_fb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "var6_video",
    transform: "translate(-498.000000, -181.000000)",
    fill: "#7F7F7F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fb",
    transform: "translate(498.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 L2,0 C0.89697,0 0,0.896973 0,2 L0,20 C0,21.10303 0.896973,22 2,22 L9.5,22 C9.776367,22 10,21.776367 10,21.5 L10,14.5 C10,14.223633 9.776367,14 9.5,14 L8.520996,14 C8.245117,14 8.020996,13.775879 8.020996,13.5 L8.020996,10.5 C8.020996,10.224121 8.245117,10 8.520996,10 L9.5,10 C9.776367,10 10,9.776367 10,9.5 L10,8.5 C10,6.01855 12.01855,4 14.5,4 L17.5,4 C17.775879,4 18,4.224121 18,4.5 L18,7.5 C18,7.775879 17.775879,8 17.5,8 L14.5,8 C14.223633,8 14,8.223633 14,8.5 L14,9.5 C14,9.776367 14.223633,10 14.5,10 L17.5,10 C17.647461,10 17.786621,10.0644531 17.881348,10.17627 C17.9765628,10.289063 18.017578,10.437012 17.993164,10.58252 L17.493164,13.58252 C17.4531249,13.824219 17.245605,14 17,14 L14.5,14 C14.223633,14 14,14.223633 14,14.5 L14,21.5 C14,21.776367 14.223633,22 14.5,22 L20,22 C21.10303,22 22,21.103027 22,20 L22,2 C22,0.89697 21.103027,0 20,0 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.83b3e51bc1fbde698b863aeb8da0dca9.svg";
export { ForwardRef as ReactComponent };